// extracted by mini-css-extract-plugin
module.exports = {"containerNews":"news_containerNews__2Yo1n","headerNews":"news_headerNews__HltlM","headerFilter":"news_headerFilter__3EK-b","containerCardNews":"news_containerCardNews__11cju"};